export const environment = {
  production: false,
  showTrialRibbon: true,
  apiUrl: 'https://api.test.iwanbooks.com/api/v1',
  googleClientId: '1079608760249-0o8jnoe1pgcm9djr5b59gmc9ld5t2lup.apps.googleusercontent.com',
  facebookAppId: '2176379803122326',
  appleClientId: 'com.iwanbooks.signin'
};

